



































import OverviewTile from '@/components/dashboards/customer_review_dashboard/OverviewTile.vue';
import PostCodesTile from '@/components/dashboards/customer_review_dashboard/PostCodesTile.vue';
import PostCodesMapTile from '@/components/dashboards/customer_review_dashboard/PostCodesMapTile.vue';
import PalletSizesTile from '@/components/dashboards/customer_review_dashboard/PalletSizesTile.vue';
import IncidentReportTile from '@/components/dashboards/customer_review_dashboard/IncidentReportTile.vue';
import OnTimeTile from '@/components/dashboards/customer_review_dashboard/OnTimeTile.vue';
import ReportControls, { ReportSpec, Account } from '@/components/ReportControls.vue';
import Vue from 'vue';
import axios from 'axios';
import html2canvas from 'html2canvas';
import SvgIcon from '@jamescoyle/vue-icon';
import { mdiAutorenew } from '@mdi/js';
import { DateTime } from "luxon";


interface DateRangeOptions {
  [year: number]: number[];
}

export default Vue.extend({
  name: 'CustomerReviewDashboard',
  components: {
    OverviewTile,
    PostCodesTile,
    PostCodesMapTile,
    PalletSizesTile,
    IncidentReportTile,
    OnTimeTile,
    ReportControls,
    SvgIcon,
  },
  data() {
    return {
      path: mdiAutorenew,
      size: 48,
      dateOptions: {} as DateRangeOptions,
      spec: {dateStyle: "calendar"} as ReportSpec,
      loading: true,
    };
  },
  computed: {
    dataUrl(): string {
      const BASE_URL = (process.env.NODE_ENV === 'production') ? '/api' : '//localhost:8000';
      if (this.spec.dateStyle === "calendar") {
        const { depot, from, to } = this.spec;
        return `${BASE_URL}/reports/customer-review-dashboard/${depot}/${DateTime.fromJSDate(from).toISODate()}/${DateTime.fromJSDate(to).toISODate()}/`;
      } else {
        const { depot, from, to } = this.spec;
        return `${BASE_URL}/reports/customer-review-dashboard/${depot}/${from.year}/${from.week}/${to.year}/${to.week}/`;
      }
    },
  },
  methods: {
    print() {
      html2canvas(document.body).then((canvas) => {
        document.body.appendChild(canvas);
        window.print();
      });
    },
  },
  watch: {
    async spec() {
      this.loading = true;
      const response = await axios.get(this.dataUrl, {
        params: {
          account_codes: this.spec.accountCodes.flatMap((a: Account) => a.codes),
        },
      });
      this.loading = false;
    },
  },
});
